import { userService } from '../../_services';
import router from '../../router/index';
import axios from 'axios';
import UserAuth from "@/auth/js";
// import { generateDeviceToken, listenForegroundMessages } from "../firebase-messaging";
const user = JSON.parse(localStorage.getItem('user'));

const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null };

export const authentication = {
    namespaced: true,

    state: initialState,

    getters: {},

    actions: {
    // async login({ dispatch, commit }, { email, passwordjwt }) {
    //     commit("loginRequest", { email });

    //     try {
    //     const user = await userService.login(email, passwordjwt);

    //     if (user.data.code !== 401) {
    //         commit("loginSuccess", user);

            
    //         const deviceToken = await generateDeviceToken();
    //         console.log("Generated device token:", deviceToken);
    //         if (deviceToken) {
    //             await dispatch("registerDeviceToken", deviceToken);
    //         }

    //         // Start foreground listener
    //         listenForegroundMessages();

    //         const redirectPath =
    //         router.currentRoute.value.query.redirect || "/";
    //         router.push(redirectPath);

    //         return user.data;
    //     } else {
    //         const error = user.data;
    //         commit("loginFailure", error.message);
    //         // dispatch("alert/error", error.message, { root: true });
    //         return error;
    //     }

    //     } catch (error) {
    //     commit("loginFailure", error.message);
    //     // dispatch("alert/error", error.message, { root: true });
    //     return error;
    //     }
    // },

    // async registerDeviceToken ({commit, dispatch}, payload) {
    //     let config = {
    //         headers: {
    //             Authorization: "Bearer " + localStorage.getItem("access_token"),
    //         }
    //     };
    //     try{
    //         let device = {
    //             device_token: payload
    //         }
    //         let response = await axios.post(V1API.device_store, device , config).then(result=>{
    //             console.log(result)
    //             let data = result.data
    //             return data
    //         });
           
    //         return response
    //     }catch (e) {
            
    //     }finally {
           
    //     }
    // },

        async login({ dispatch, commit }, { email, passwordjwt }) {
            commit('loginRequest', { email });
            let response = await userService.login(email, passwordjwt).then(
                user => {
                    if(user.data.code!=401) {
                        commit('loginSuccess', user);
                        // console.log(user)
                        const redirectPath = router.currentRoute.query.redirect || '/';
                        router.push(redirectPath);

                    } else {
                        let error = user.data
                        commit('loginFailure', error.message);
                        dispatch('alert/error', error.message, { root: true });
                        return error
                    }

                    // console.log(user)
                    return user.data
                },
                error => {
                    // console.log(error)
                    commit('loginFailure', error.message);
                    dispatch('alert/error', error.message, { root: true });
                }
            );

            return response
        },

        logout({ commit }) {
            userService.logout();
            UserAuth.Logout();
            router.replace('/auth/login');
            commit('logout');
        },

        async verify_token({dispatch}, payload) {
            let response= await userService.verify(payload).then(data=>{
               return data
            });

            if(response) {
                console.log('access token verified -->', response)
                return response
            } else  {
                userService.verifyRefresh()
            }
        }
    },

    mutations: {
        loginRequest(state, user) {
            state.status = { loggingIn: true };
            state.user = user;
        },

        loginSuccess(state, user) {
            state.status = { loggedIn: true };
            state.user = user;
        },

        loginFailure(state) {
            state.status = {};
            state.user = null;
        },

        logout(state) {
            state.status = {};
            state.user = null;
        }
    }
};
